module.exports = __webpack_public_path__ + "static/the-house-of-mirth-b915fa1d9ec418e9b4cf0bb2381a4fc6.jpg";